import moment from 'moment-timezone'

/*
 * HERA-9129: pure helpers for the Scheduling & Rostering Bootstrap card.
 * Status comes from executeMutation `tenant-bootstrap`:
 *   { state: 'not-bootstrapped' | 'in-progress' | 'done' | 'failed', bootstrappedAt, updatedAt }
 */

export const POLL_INTERVAL_MS = 5000

export const LOAD_ERROR_MESSAGE = 'Could not load the bootstrap status.'
export const FORBIDDEN_MESSAGE = "You don't have permission to bootstrap Tenants."

// Amplify API (axios) puts the HTTP status on error.response.status.
export const isForbiddenError = error => error?.response?.status === 403

export const loadErrorMessage = error => (isForbiddenError(error) ? FORBIDDEN_MESSAGE : LOAD_ERROR_MESSAGE)

export const BOOTSTRAP_AGAIN_CONFIRM =
  'Bootstrap Again only adds lists, options and Shift Type rules that are missing, ' +
  'including default options that were deleted. Nothing that already exists is changed.'

// Same format the app uses for times (src/components/Profile/CompanyTime.vue), e.g. "Oct 15, 3:06 AM".
export const BOOTSTRAP_DATE_FORMAT = 'MMM DD, YYYY, h:mm A'

// The stored time is UTC; show it in the signed-in Tenant's time zone, like the rest of the app.
export function formatBootstrapDate(iso, timeZone) {
  if (!iso) return ''
  const date = moment.utc(iso)
  if (!date.isValid()) return ''
  return (timeZone ? date.tz(timeZone) : date.local()).format(BOOTSTRAP_DATE_FORMAT)
}

export function alreadyBootstrappedMessage(status, timeZone) {
  const date = formatBootstrapDate(status?.bootstrappedAt || status?.updatedAt, timeZone)
  return date ? `This Tenant was already bootstrapped on ${date}.` : 'This Tenant was already bootstrapped.'
}

export function cardView(status, timeZone) {
  const state = status?.state
  switch (state) {
    case 'in-progress':
      return {
        state,
        icon: 'uil uil-sync',
        tone: 'text-blue-600',
        message: 'Bootstrapping is in progress. This can take a minute.',
        buttonLabel: 'Bootstrapping...',
        buttonDisabled: true,
        isAgain: false,
      }
    case 'done': {
      const date = formatBootstrapDate(status.bootstrappedAt || status.updatedAt, timeZone)
      return {
        state,
        icon: 'uil uil-check-circle',
        tone: 'text-green-600',
        message: date ? `Bootstrapped on ${date}.` : 'Bootstrapped.',
        buttonLabel: 'Bootstrap Again',
        buttonDisabled: false,
        isAgain: true,
      }
    }
    case 'failed':
      return {
        state,
        icon: 'uil uil-exclamation-triangle',
        tone: 'text-red-600',
        message: 'Bootstrapping did not finish. Try Again to finish the missing parts. Nothing is created twice.',
        buttonLabel: 'Try Again',
        buttonDisabled: false,
        isAgain: false,
      }
    default:
      return {
        state: 'not-bootstrapped',
        icon: 'uil uil-info-circle',
        tone: 'text-gray-600',
        message: "This Tenant's Scheduling & Rostering setup has not been bootstrapped yet.",
        buttonLabel: 'Bootstrap',
        buttonDisabled: false,
        isAgain: false,
      }
  }
}
